import { Component, OnInit, NgZone } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { Router, ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-auth-screen',
  templateUrl: './auth-screen.component.html',
  styleUrls: ['./auth-screen.component.css']
})
export class AuthScreenComponent implements OnInit {
  logIn = true;
  userId;
  url = 'https://apis.google.com/js/platform.js';

  constructor(private authApi: AuthService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private ngZone: NgZone,
    private router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    (window as any).googleLogin = this.googleLogin;
    this.loadScript()
  }

  switcheAuthType() {
    this.logIn = !this.logIn;
  }

  onSubmit(form: NgForm) {
    if (!form.valid) {
      this.toastr.error("Please enter valid user Id / Password");
      return
    }
    this.spinner.show();
    if (this.logIn) {
      this.authApi.logIn(form.value.email, form.value.password).subscribe((data) => {
        this.spinner.hide();
        this.toastr.success("Successfully Logged in", "Kudos Gammer");
        this.navigator();
      })
    } else {
      this.authApi.signIn(form.value.userId, form.value.email, form.value.password).subscribe((data) => {
        this.spinner.hide();
        this.toastr.success("Signed in successfully", "Kudos Gammer");
        this.navigator();
      })

    }

    form.reset()
  }
  navigator() {
    const event_id = this.route.snapshot.queryParams["event_id"];
    if (event_id) {
      return this.router.navigate(['/events'], { queryParams: { event_id } })
    }
    this.router.navigate([''])
  }

  public loadScript() {
    let node = document.createElement('script');
    node.src = this.url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  googleLogin = (googleUser) => {
    this.spinner.show();
    this.backend(googleUser)
  }

  backend(googleUser) {

    this.authApi.authGoogleUser(googleUser.getAuthResponse().id_token).pipe(
      take(1)
    ).subscribe((data) => {
      if (!data) { return }
      this.ngZone.run(() => {
        this.spinner.hide();
        this.toastr.success("Signed in successfully", "Kudos Gammer");
        this.navigator()
      })
    })

  }
  ;
}
